import React from "react";
import classNames from "classnames";

type SVGIconProps = {
    className?: string;
    icon: string;
    onClick?: (e: React.MouseEvent) => void;
    disabled?: boolean;
    style?: object;
} & React.SVGProps<SVGSVGElement>;

const SVGIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
    ({ className, icon, onClick, ...props }, ref) => (
        <svg
            className={classNames(`wsicon-${icon}`, className, "wsicon")}
            onClick={onClick}
            {...props}
            ref={ref}
        >
            <use xlinkHref={`#wsicon-${icon}`} />
        </svg>
    ),
);

export default SVGIcon;
